import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3586784a"
import script from "./purchaseRequisition.js?vue&type=script&lang=js&external"
export * from "./purchaseRequisition.js?vue&type=script&lang=js&external"
import style0 from "./purchaseRequisition.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports